export default __webpack_public_path__ + "static/media/svg-couvert.6821eb0b.svg";